import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useSaasSubscription({ enabled = true } = {}) {
  return useQuery({
    queryKey: ["saas", "subscription"],
    queryFn: () => apiClient.get("/api/v1/saas/subscription/").then((r) => r.data),
    enabled,
  });
}

// Preview: qué pasaría al cambiar a `planId` (result, requires_selection,
// overages, features_lost) — se usa para abrir el wizard de downgrade.
function usePlanChangePreview() {
  return useMutation({
    mutationFn: (planId) =>
      apiClient
        .post("/api/v1/saas/subscription/preview/", { plan_id: planId })
        .then((r) => r.data),
  });
}

function useChangePlan() {
  const qc = useQueryClient();
  return useMutation({
    // Backend write field is `plan_id`; `keep` (opcional) es la selección del
    // wizard de downgrade {recurso: [ids a conservar]}.
    mutationFn: ({ planId, keep }) =>
      apiClient
        .patch("/api/v1/saas/subscription/", {
          plan_id: planId,
          ...(keep ? { keep } : {}),
        })
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["saas", "subscription"] });
      qc.invalidateQueries({ queryKey: ["saas", "plans"] });
    },
  });
}

export { useSaasSubscription, usePlanChangePreview, useChangePlan };
